
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(window.flitsObjects.allCssJs.socialLoginJs){
        Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  if(Flits.Metafields.IS_STORE_CREDIT_PAID && Flits.Metafields.is_store_credit_enable && window.flitsObjects.storeData.customer_id != -1){
    Flits.LoadStyleScript('cartJs',window.flitsObjects.allCssJs.cartJs.url);
  }
  if(Flits.Metafields.IS_WISHLIST_PAID && Flits.Metafields.IS_WISHLIST_ENABLE){
    Flits.LoadStyleScript('wishlistJs',window.flitsObjects.allCssJs.wishlistJs.url);
  }
  Flits.extend({
    getCartAjaxEventCustom: function() {
      var getCartFunction = function(xhrOrFetch) {
        var url = this._url;
        url.indexOf('flits') === -1 && ((url.indexOf('/cart.js') !== -1 && url.indexOf('/cart.js?internal') == -1) || url.indexOf('/cart?view=drawer') !== -1) && Flits.dispatchEvent('Flits:AjaxCart:CartRenderedCustom', {
          response: this,
          xhrOrFetch: xhrOrFetch
        });
      };
      Flits.addAjaxEvents(getCartFunction),
        Flits.addFetchEvents(getCartFunction);
    },
    redirectToCheckout: async function (parameters) {
      parameters = parameters || {};
      var form = Flits(Flits.StoreCreditCart.settings.checkoutFormSelectors.join(','));
      if (form.length <= 0) {
        // location.href = "/checkout?" + Flits.param(parameters);   
        location.href = location.origin+"/discount/"+parameters?.discount+"?redirect=/checkout";
        return true;
      }
      fetch(`/discount/${parameters?.discount}`)
        .then(function() {
            var form_action = form.attr("action");
            var form_action_data = Flits.parseURL(form_action);
      
            Flits.each(parameters, function (index, item) {
              var existing = form.find("[name='" + index + "']");
              if (existing.length <= 0) {
                form.append("<input type='hidden' name='" + index + "' value='" + item + "'>");
              } else {
                existing.val(item);
              }
              if (form_action_data.searchObject[index]) {
                form_action = form_action.replace(index + '=' + form_action_data.searchObject[index], item);
              } else {
                form_action += (form_action.indexOf('?') !== -1 ? "&" : "?") + index + "=" + item;
              }
            });
            form.append("<input type='hidden' name='checkout' value='true'>");
            form.attr("action", form_action);
            form.trigger('submit', [{ flitsFormSubmitted: true }]);
      });
    }
  });
  Flits(document).on('Flits:wishlistButton:Loaded', function(event){
    setTimeout(function(){
      let collectionBtn = Flits(".flits-wishlist-colection");
      parseInt(Flits.wishlistButton.settings.isCountEnable) && Flits(collectionBtn).find(".flits-wls-count-btn").css("display", "flex"),
        Flits(collectionBtn).show(),
        Flits(".flits-wishlist-colection:not(.flits-template)").parent().attr("data-flits", "wishlist-collection-parent");
    }, 3000);
  });
  
  Flits(document).on('Flits:StoreCreditCart:Loaded', function(event){
   	var settings = event.detail.settings;
    event.detail.settings.checkoutButtonSelectors.push(".btn-checkout");
  });
  
    Flits(document).on('Flits:SocialLoginAutomaticCode:Loaded', function(event){  
    var data = event.detail;
      if(Flits(event.detail.parent[0].parentElement).hasClass('header__menu-login-content')){
    	Flits(event.detail.cloneNode).insertAfter(event.detail.el[0]);
    	//Flits('<div id="flits-social-header"><h3>Or cLogin With Social</h3></div>').insertAfter(event.detail.el[0]);
      }
      else{
        Flits(event.detail.cloneNode).insertAfter(event.detail.parent[0].children[2]);
        
    	//Flits('<div id="flits-social-header"><h3>Or Login With Social</h3></div>').insertAfter(event.detail.parent[0].children[1]);
        
      }
  });
  
 // Below Code for Quick View.
  
  var ajaxWishlistViewFunction = function(xhrOrFetch) {
    var url = this._url;

    // You can add your choice of URL Instead '?view=ajax'
    (-1 !== url.indexOf("?view=quickview")) && Flits.dispatchEvent("Flits:AjaxWishlist", { 
      response: this,
      xhrOrFetch: xhrOrFetch
    })
  };
  Flits.addAjaxEvents(ajaxWishlistViewFunction);
  Flits.addFetchEvents(ajaxWishlistViewFunction);
  
  function flitsShowWishlistButton(){
    let collectionBtn = Flits('#CollectionSection .flits-wishlist-colection');
    parseInt(Flits.wishlistButton.settings.isCountEnable) && Flits(collectionBtn).find('.flits-wls-count-btn').css('display', 'flex'),
      Flits(collectionBtn).show(),
      Flits('.flits-wishlist-colection:not(.flits-template)').parent().attr('data-flits', 'wishlist-collection-parent'); 
  }
  Flits(document).on("Flits:AjaxWishlist", function(){
    setTimeout(function(){  
      var grid = Flits("#add-to-cart-quickview-form").find(".flits-wishlist-colection .flits-wls-button");
      Flits(grid).each(function(index,single_grid_item){
        var handle = Flits(single_grid_item).attr('data-flits-product-handle');
        Flits(single_grid_item).parent().css('display','flex');
        Flits(single_grid_item).find('.flits-wls-icon-with-text-text').css('display','flex');
        if(Flits.isProductAddedInWishlist(handle)){ 
          Flits(single_grid_item).removeClass("flits-wls-inactive");
          Flits(single_grid_item).addClass("flits-wls-active");
        }
      });
    }, 1000);
  });

  // Below code for Load more 

  var ajaxWishlistViewFunction = function(xhrOrFetch) {
    var url = this._url;

    // You can add your choice of URL Instead '?view=ajax'
    (-1 !== url.indexOf("?page=") || -1 !== url.indexOf("?section_id=") ) && Flits.dispatchEvent("Flits:AjaxWishlist", { 
      response: this,
      xhrOrFetch: xhrOrFetch
    })
  };
  Flits.addAjaxEvents(ajaxWishlistViewFunction);
  Flits.addFetchEvents(ajaxWishlistViewFunction);

  //   function flitsShowWishlistButton(){
  //     let collectionBtn = Flits('#CollectionSection .flits-wishlist-colection');
  //     parseInt(Flits.wishlistButton.settings.isCountEnable) && Flits(collectionBtn).find('.flits-wls-count-btn').css('display', 'flex'),
  //       Flits(collectionBtn).show(),
  //       Flits('.flits-wishlist-colection:not(.flits-template)').parent().attr('data-flits', 'wishlist-collection-parent'); 
  //   }
  Flits(document).on("Flits:AjaxWishlist", function(){
    setTimeout(function(){  
      var grid = Flits("#CollectionProductGrid").find(".flits-wishlist-colection .flits-wls-button");
      Flits(grid).each(function(index,single_grid_item){
        var handle = Flits(single_grid_item).attr('data-flits-product-handle');
        Flits(single_grid_item).parent().css('display','flex');
        Flits(single_grid_item).find('.flits-wls-icon-with-text-text').css('display','flex');
        if(Flits.isProductAddedInWishlist(handle)){ 
          Flits(single_grid_item).removeClass("flits-wls-inactive");
          Flits(single_grid_item).addClass("flits-wls-active");
        }
      });
    }, 1000);
  });
}(Flits));
